import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a routing icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <CircleArrowLeftIcon width={12} />
 */
const CircleArrowLeftIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M24,44A20,20,0,1,0,4,24,20.06,20.06,0,0,0,24,44ZM12.24,23.05h0L22,13.21a1.34,1.34,0,0,1,
        2.28.95v7H34.74a1.41,1.41,0,0,1,1.41,1.41v2.84a1.41,1.41,0,0,1-1.41,1.41H24.32v7A1.33,1.33,0,0,1,
        23,35.18a1.29,1.29,0,0,1-.93-.39L12.24,25A1.35,1.35,0,0,1,12.24,23.05Z`}
        />
    </SvgIcon>
)

CircleArrowLeftIcon.defaultProps = defaultProps

export { CircleArrowLeftIcon }
